<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-stock-count-sidebar ref="handleStockCountSidebar" />

    <vs-prompt
      @cancel="createPromptActive = false"
      @close="createPromptActive = false"
      @accept="createStockCount"
      title="Create new stock count"
      accept-text="Create"
      :active.sync="createPromptActive"
    >
      <div>
        <div>Click here to create a new stock count. It can later be adapted</div>
        <!-- <vs-checkbox
          v-model="startWithSuggested"
          label="Start with suggested order lines"
          class="mt-4"
          color="primary"
        >
          Start with suggested order lines
        </vs-checkbox> -->
      </div>
    </vs-prompt>

    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div class="flex justify-end">
        <vs-button icon="add" @click="onClickCreateNew" type="relief" color="primary" class="mr-3">New stock count</vs-button>
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="10" :data="filteredStockCounts" @selected="onClicked">
        <template slot="thead">
          <vs-th sort-key="vendorName">Type</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th>Lines</vs-th>
          <vs-th sort-key="deadlineDate">Deadline</vs-th>
          <vs-th>Activated at</vs-th>
          <vs-th>Completed at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start">
                    <img width="40" :src="OrderIcon" />
                    <div class="ml-4">
                      <div v-if="tr.isCreatedManually">Forced count</div>
                      <div v-else>Automatic count</div>
                      <small class="text-grey">{{ tr.shortId }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <vs-chip :color="stateMapping[tr.status].color">
                  {{ stateMapping[tr.status].label }}
                </vs-chip>
              </vs-td>

              <vs-td>
                {{ tr.stockCountLines.length }}
              </vs-td>

              <vs-td>
                <div class="flex">
                  <feather-icon class="mr-1" icon="CalendarIcon" svgClasses="text-grey w-5 h-5" />
                  {{ tr.deadlineDate | formatDate }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.activatedAction" class="flex">
                  <feather-icon class="mr-1" icon="CalendarIcon" svgClasses="text-grey w-5 h-5" />
                  {{ tr.activatedAction.timestamp | formatDate }}
                </div>
              </vs-td>

              <vs-td>
                <div v-if="tr.countedAction" class="flex">
                  <feather-icon class="mr-1" icon="CalendarIcon" svgClasses="text-grey w-5 h-5" />
                  {{ tr.countedAction.timestamp | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderIcon from "@/assets/images/order-icon.png";
import moment from "moment";
import HandleStockCountSidebar from "./StockCountSidebar.vue";

export default {
  components: {
    HandleStockCountSidebar
  },
  props: {
    venueId: {
      type: String,
      default: undefined,
      required: false
    }
  },
  data() {
    return {
      OrderIcon,
      isLoading: true,

      //Create popup
      startWithSuggested: false,
      createPromptActive: false,

      activeVenueId: null
    };
  },
  watch: {
    venueId: {
      handler: async function () {
        this.isLoading = true;
        this.activeVenueId = this.venueId;
        // If no venue id specified, default to active venue
        if (typeof this.venueId == "undefined") {
          this.activeVenueId = this.$store.getters["venues/activeVenueId"];
        }

        await this.$store.dispatch("pos/stockCounts/getStockCountsByVenue", this.activeVenueId);

        this.isLoading = false;
      },
      immediate: true
    }
  },
  methods: {
    onClickCreateNew() {
      this.createPromptActive = true;
    },

    async createStockCount() {
      try {
        console.log("creating stock count");
        var response = await this.$store.dispatch("pos/stockCounts/createStockCount", {
          venueId: this.activeVenueId
        });

        this.$refs.handleStockCountSidebar.show(response);

        await this.$store.dispatch("pos/stockCounts/getStockCountsByVenue", this.activeVenueId); // Refresh stock counts

        this.$vs.notify({
          title: "Stock count created",
          text: "A new draft stock count has been created."
        });
        this.startWithSuggested = false;
        this.createPromptActive = false;
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to create stock count: ${err}`,
          color: "danger"
        });
        console.error(err);
      }
    },
    onClicked(item) {
      this.$refs.handleStockCountSidebar.show(item.id);
    },
    // Check if date is valid using moment
    isValidDate(date) {
      if (!date) return false;
      return moment(date).year() > 1;
    }
  },
  computed: {
    ...mapGetters({
      stateMapping: "pos/stockCounts/stateMapping",
      stockCounts: "pos/stockCounts/stockCounts"
    }),
    filteredStockCounts() {
      return this.stockCounts.slice().sort((a, b) => (a.createdAction.timestamp < b.createdAction.timestamp ? 1 : -1));
    }
  }
};
</script>